import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { atualizarCadastroFamiliaV2, obterFamiliaPeloCPFIntegranteFamiliar } from '../../api/familiaAPI';
import { RootState } from '../../app/store';

export interface AtualizacaoCadastralState {
  isRevisaoIniciada: any;
  exibirEndereco: any;
  familia: any;
  isEnderecoConfirmado: boolean;
  isContatoConfirmado: boolean;
  isComposicaoFamiliarConfirmada: boolean;
  codigoErro: string;
  mensagemErro: string;
  responseError: any;
}

const initialState: AtualizacaoCadastralState = {
  isRevisaoIniciada: false,
  exibirEndereco: false,
  familia: null,
  isEnderecoConfirmado: false,
  isContatoConfirmado: false,
  isComposicaoFamiliarConfirmada: false,
  codigoErro: "",
  mensagemErro: "",
  responseError: null,
};

export const obterFamilia = createAsyncThunk(
  'atualizacaoCadastral/obterFamilia',
  async (cpf: string) => {
    return obterFamiliaPeloCPFIntegranteFamiliar(cpf);
  }
);

export const atualizarFamiliaV2 = createAsyncThunk(
  'atualizacaoCadastral/atualizarFamilia',
  async (familia: any) => {
    return atualizarCadastroFamiliaV2(familia);
  }
);

export const atualizacaoCadastralSlice = createSlice({
  name: 'atualizacaoCadastral',
  initialState,
  reducers: {
    setIniciarRevisao: (state, action) => {
      state.isRevisaoIniciada = action.payload;
    },
    setExibirEndereco: (state, action) => {
      state.exibirEndereco = action.payload;
    },
    setEnderecoConfirmado: (state, action) => {
      state.isEnderecoConfirmado = action.payload;
    },
    setContatoConfirmado: (state, action) => {
      state.isContatoConfirmado = action.payload;
    },
    setComposicaoFamiliarConfirmada: (state, action) => {
      state.isComposicaoFamiliarConfirmada = action.payload;
    },
    setContatos: (state, action) => {
      state.familia.contatos = action.payload;
    },
    limpar: (state) => {
      state.familia = null;
      state.codigoErro = "";
      state.mensagemErro = "";
      state.isRevisaoIniciada = false;
      state.isEnderecoConfirmado = false;
      state.isContatoConfirmado = false;
      state.isComposicaoFamiliarConfirmada = false;
    },
    limparResponseError: (state) => {
      state.responseError = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(obterFamilia.fulfilled, (state, action) => {
      if (action.payload.codigoErro !== "0") {
        state.codigoErro = action.payload.codigoErro;
        state.mensagemErro = action.payload.mensagemErro;
      }

      state.familia = action.payload.familia;
    });
    builder.addCase(atualizarFamiliaV2.fulfilled, (state, action) => {
      state.codigoErro = action.payload.codigoErro;
      state.mensagemErro = action.payload.mensagemErro;
    });
    builder.addCase(atualizarFamiliaV2.rejected, (state, action) => {
      state.responseError = action.error;
    });
  },
});

export const {setIniciarRevisao, setExibirEndereco, setContatos,
  setEnderecoConfirmado, setContatoConfirmado, setComposicaoFamiliarConfirmada, limpar, limparResponseError} = atualizacaoCadastralSlice.actions;

export const selectFamilia = (state: RootState) => state.atualizacaoCadastral.familia;
export const selectRevisaoIniciada = (state: RootState) => state.atualizacaoCadastral.isRevisaoIniciada;
export const selectExibirEndereco = (state: RootState) => state.atualizacaoCadastral.exibirEndereco;
export const selectEnderecoConfirmado = (state: RootState) => state.atualizacaoCadastral.isEnderecoConfirmado;
export const selectContatoConfirmado = (state: RootState) => state.atualizacaoCadastral.isContatoConfirmado;
export const selectComposicaoFamiliarConfirmada = (state: RootState) => state.atualizacaoCadastral.isComposicaoFamiliarConfirmada;
export const selectCodigoErro = (state: RootState) => state.atualizacaoCadastral.codigoErro;
export const selectMensagemErro = (state: RootState) => state.atualizacaoCadastral.mensagemErro;
export const selectResponseError = (state: RootState) => state.atualizacaoCadastral.responseError;

export default atualizacaoCadastralSlice.reducer;
